import React from 'react';
import PropTypes from 'prop-types';
import { INPUT_CLS, INPUT_ERROR_CLS } from 'helpers/formStyles';

/**
 * FormSelect component for dropdown selections
 * Supports label, error state, and disabled state
 */
const FormSelect = ({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  error,
  disabled = false,
  required = false,
  className = '',
  ...props
}) => {
  const baseClasses = `${INPUT_CLS} tw-cursor-pointer`;
  const errorClass = error ? INPUT_ERROR_CLS : '';

  return (
    <div className="tw-flex tw-flex-col tw-gap-1.5">
      {label && (
        <label className="tw-text-sm tw-font-medium tw-text-slate-700">
          {label}
          {required && <span className="tw-text-red-500 tw-ml-1">*</span>}
        </label>
      )}

      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${baseClasses} ${errorClass} ${className}`}
        {...props}
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <p className="tw-text-xs tw-text-red-600 tw-font-medium">{error}</p>
      )}
    </div>
  );
};

FormSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default FormSelect;
